export default {"src":"/_next/static/media/illustration-kibble.cea5b1de.svg","height":82,"width":118};